import React, { useState } from "react";
import { Box, Typography, Button, TextField, Snackbar } from "@mui/material";
import { Lock } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { useUser } from "../hooks/Authorize";
import axios from "axios";

const AccessDenied = ({ resourceName = "this item", resourceType = "file or folder" }) => {
  const navigate = useNavigate();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [emailError, setEmailError] = useState("");
  const platformUser = JSON.parse(localStorage.getItem("user"));
  const [email, setEmail] = useState(platformUser.email || '');

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const resourceId = queryParams.get('id') || queryParams.get('parentId');

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };
  const handleRequestAccess = async () => {
    if (!email) {
      setEmailError("Email is required");
      return;
    }
    if (!validateEmail(email)) {
      setEmailError("Please enter a valid email");
      return;
    }

    setEmailError("");

    try {
      setSnackbarOpen(true);
      await axios.post(
        `${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs/request-access`,
        {
          resourceId: resourceId,
          requesterEmail: email
        }

      );

    } catch (error) {
      setEmailError(error.response?.data?.message || "Failed to send request");
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "calc(100vh - 200px)",
        textAlign: "center",
        p: 4,
      }}
    >
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        message="Request sent for Access"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        sx={{
          '& .MuiSnackbarContent-root': { 
            backgroundColor: "#191919",
            background: "rgba(31, 31, 31, 1)",
            color: '#fff',
          }
        }}
      />
      <Box
        sx={{
          width: 120,
          height: 120,
          borderRadius: "50%",
          bgcolor: "#FCE8E6",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 3,
        }}
      >
        <Lock sx={{ fontSize: 60, color: "#D93025" }} />
      </Box>

      <Typography variant="h5" sx={{ mb: 1, fontWeight: 500 }}>
        You need access
      </Typography>

      <Typography variant="body1" sx={{ mb: 2, color: "text.secondary", maxWidth: "500px" }}>
        Request access or switch to an account with permission to view {resourceName}.
        This {resourceType} is owned by someone else.
      </Typography>

      {!platformUser.email &&
        <TextField
          variant="outlined"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          error={!!emailError}
          helperText={emailError}
          placeholder="Enter your email"
          sx={{
            width: "100%",
            maxWidth: "500px",
            mb: 3, // Added space below
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              fontSize: "12px", // Input text size
              padding: "5px 10px",
              ...(emailError && {
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "red", // Red border for invalid email
                  borderWidth: "1px"
                }
              }),
              ...(!emailError && email && {
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "primary.main", // Blue border when valid
                  borderWidth: "1px"
                }
              })
            },
            "& .MuiInputBase-input": {
              fontSize: "12px", // Ensures input text size
              padding: "5px 5px",

            },
            "& .MuiFormHelperText-root": {
              fontSize: "12px", // Error text size
            }
          }}
        />}
      <Box sx={{ display: "flex", gap: 2, mt: 2, justifyContent: "space-between" }}>
        <Button
          variant="contained"
          onClick={handleRequestAccess}

          sx={{
            bgcolor: "#1A73E8",
            "&:hover": { bgcolor: "#1765CC" },
            textTransform: "none",
            px: 3,
            py: 1,
          }}
        >
          Request access
        </Button>

        <Button
          variant="outlined"
          onClick={() => navigate("/")}


          sx={{
            textTransform: "none",
            px: 3,
            py: 1,
            borderColor: "#DADCE0",
            color: "#3C4043",
          }}
        >
          Go to Home
        </Button>
      </Box>

      <Typography variant="body2" sx={{ mt: 4, color: "text.secondary" }}>
        Having trouble? Try these steps:
      </Typography>
      <Box sx={{ textAlign: "left", maxWidth: "500px", mt: 1 }}>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          1. Make sure you're signed in to the correct account
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          2. Contact the owner to request access
        </Typography>
      </Box>
    </Box>
  );
};

export default AccessDenied;